import paracetamol from './assets/Medicines/paracetamol.png'
import SearchBar from './components/SearchBar/SearchBar';
import pharmacy_shop from './assets/pharmacy_shop.jpg'
export const homepage_category = [
    {
      headTitle: "Popular Medicine",
      categoryArray: [
        {
          title: "Paracetamol",
          imageUrl: paracetamol,
          description: "Tablets for fever - Paracetamol",
          price: "20",
        },
        {
          title: "Ranitidine",
          imageUrl: paracetamol,
          description: "Tablets for fever - Paracetamol",
          price: "210",
        },
        {
          title: "Paracetamol",
          imageUrl: paracetamol,
          description: "Tablets for fever - Paracetamol",
          price: "200",
        },
        {
          title: "Azithromycin",
          imageUrl: paracetamol,
          description: "Tablets for fever - Paracetamol",
          price: "120",
        },
        {
            title: "Paracetamol",
            imageUrl: paracetamol,
            description: "Tablets for fever - Paracetamol",
            price: "20",
          },
          {
            title: "Paracetamol",
            imageUrl: paracetamol,
            description: "Tablets for fever - Paracetamol",
            price: "20",
          },
          {
            title: "Paracetamol",
            imageUrl: paracetamol,
            description: "Tablets for fever - Paracetamol",
            price: "20",
          },
      ],
    },
    {
        headTitle: "New Arrivals",
        categoryArray: [
          {
            title: "Paracetamol",
            imageUrl: paracetamol,
            description: "Tablets for fever - Paracetamol",
            price: "20",
          },
          {
            title: "Ranitidine",
            imageUrl: paracetamol,
            description: "Tablets for fever - Paracetamol",
            price: "210",
          },
          {
            title: "Ibuprofen",
            imageUrl: paracetamol,
            description: "Tablets for fever - Paracetamol",
            price: "200",
          },
          {
            title: "Azithromycin",
            imageUrl: paracetamol,
            description: "Tablets for fever - Paracetamol",
            price: "120",
          },
          {
              title: "Omeprazole",
              imageUrl: paracetamol,
              description: "Tablets for fever - Paracetamol",
              price: "20",
            },
            {
              title: "Dolo",
              imageUrl: paracetamol,
              description: "Tablets for fever - Paracetamol",
              price: "20",
            },
            {
              title: "Zycan",
              imageUrl: paracetamol,
              description: "Tablets for fever - Paracetamol",
              price: "20",
            },
        ],
      },
  ];

  export const searchBarTest = [

    {
      _id: 1,
      title: "Paracetamol",
      imageUrl: paracetamol,
      description: "Tablets for fever - Paracetamol",
      bigDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamcot",
      price: "20",
      quantity: 1,
    },
    {
      _id: 2,
      title: "Ranitidine",
      imageUrl: paracetamol,
      description: "Tablets for fever - Paracetamol",
      bigDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamcot",
      price: "210",
      quantity: 1,
    },
    {
      _id: 3,
      title: "Ibuprofen",
      imageUrl: paracetamol,
      description: "Tablets for fever - Paracetamol",
      bigDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamcot",
      price: "200",
      quantity: 1,
    },
    {
      _id: 4,
      title: "Azithromycin",
      imageUrl: paracetamol,
      description: "Tablets for fever - Paracetamol",
      bigDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamcot",
      price: "120",
      quantity: 1,
    },
    {
      _id: 5,
        title: "Omeprazole",
        imageUrl: paracetamol,
        description: "Tablets for fever - Paracetamol",
        bigDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamcot",
        price: "20",
        quantity: 1,
      },
      {
        _id: 6,
        title: "Dolo",
        imageUrl: paracetamol,
        description: "Tablets for fever - Paracetamol",
        bigDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamcot",
        price: "20",
        quantity: 1,
      },
      {
        _id: 7,
        title: "Zycan",
        imageUrl: paracetamol,
        description: "Tablets for fever - Paracetamol",
        bigDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamcot",
        price: "20",
        quantity: 1,
      },

  ]

  export const newSearchBarTest = [

    {
      _id: 1,
      title: "Paracetamol",
      imageUrl: paracetamol,
      description: "Tablets for fever - Paracetamol",
      bigDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamcot",
      price: "20",
      quantity: 1,
    },
    {
      _id: 2,
      title: "Ranitidine",
      imageUrl: paracetamol,
      description: "Tablets for fever - Paracetamol",
      bigDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamcot",
      price: "210",
      quantity: 1,
    },
    {
      _id: 3,
      title: "Ibuprofen",
      imageUrl: paracetamol,
      description: "Tablets for fever - Paracetamol",
      bigDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamcot",
      price: "200",
      quantity: 1,
    },
    {
      _id: 4,
      title: "Azithromycin",
      imageUrl: paracetamol,
      description: "Tablets for fever - Paracetamol",
      bigDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamcot",
      price: "120",
      quantity: 1,
    },
    {
      _id: 5,
        title: "Omeprazole",
        imageUrl: paracetamol,
        description: "Tablets for fever - Paracetamol",
        bigDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamcot",
        price: "20",
        quantity: 1,
      },
      {
        _id: 6,
        title: "Dolo",
        imageUrl: paracetamol,
        description: "Tablets for fever - Paracetamol",
        bigDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamcot",
        price: "20",
        quantity: 1,
      },
      {
        _id: 7,
        title: "Zycan",
        imageUrl: paracetamol,
        description: "Tablets for fever - Paracetamol",
        bigDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamcot",
        price: "20",
        quantity: 1,
      },
  ]

  export const dummy_notification = 
  [

    

     "Hello there! Your order will arrive shortly",
     "Hello there! Your order will arrive shortly",
      "Hello there! Your order will arrive shortly",
      "Hello there! Your order will arrive shortly",
      "The shopkeeper has verified your prescription. Click here to order now!"

  


    
  

  ]
  
  
  export const userInfo =
  {
     firstName: 'Nilankoor',
     lastName: 'Biswas',
     dob:'02/05/1999',
     phoneNumber: '7001345668',
     emailId: 'nilankoorb@gmail.com',
     addressLine1: 'Debinagar, Maynaguri, Jalpaiguri',
     addressLine2: 'Jalpaiguri',
     state: 'West Bengal',
  
     pinCode: '735224',
     
  }

  
  export const blank =
  {
     firstName: '',
     lastName: '',
     dob:'',
     phoneNumber: '',
     emailId: '',
     addressLine1: '',
     addressLine2: '',
     state: 'West Bengal',
  
     pinCode: '',
     
  }
  export const singleProduct ={
    _id: 7,
    title: "Zycan",
    imageUrl: paracetamol,
    description: "Tablets for fever - Paracetamol",
    bigDescription: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    price: 30,
    quantity: 1,
    additionalInfo: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamcot",
  }

  export const shops = [{
    _id: 1,
    name: "Apollo Pharmacy",
    imageUrl: pharmacy_shop,
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    address: "EM-4 Block, Sector IV, Salt Lake",

  },
  {
    _id: 2,
    name: "Opennhi Pharmacy",
    imageUrl: pharmacy_shop,
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    address: "EM-4 Block, Sector IV, Salt Lake",
  },
  {
    _id: 3,
    name: "Amaksa Pharmacy",
    imageUrl: pharmacy_shop,
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    address: "EM-4 Block, Sector IV, Salt Lake",

  },
  {
    _id: 4,
    name: "Champion Pharmacy",
    imageUrl: pharmacy_shop,
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    address: "EM-4 Block, Sector IV, Salt Lake",

  },
  {
    _id: 5,
    name: "Franklin Pharmacy",
    imageUrl: pharmacy_shop,
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    address: "EM-4 Block, Sector IV, Salt Lake",

  },
  {
    _id: 6,
    name: "Jetski Pharmacy",
    imageUrl: pharmacy_shop,
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    address: "EM-4 Block, Sector IV, Salt Lake",

  },
  {
    _id: 7,
    name: "Maa Durga Pharmacy",
    imageUrl: pharmacy_shop,
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    address: "EM-4 Block, Sector IV, Salt Lake",

  },
  {
    _id: 8,
    name: "Gupta Pharmacy",
    imageUrl: pharmacy_shop,
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    address: "EM-4 Block, Sector IV, Salt Lake",

  },
  {
    _id: 9,
    name: "Frank and Ross Pharmacy",
    imageUrl: pharmacy_shop,
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    address: "EM-4 Block, Sector IV, Salt Lake",

  },
]

export const locationArray=[

  "Salt Lake",
  "New Town",
  "Bangur",
  "Lake Town",
  
]